import config from "../config"
import {CalcSign, ResponseCode} from "../apilist/util"
import qs from "qs"

export function CreateWebsocket(url){
	let {sign, timestamp} = CalcSign();
	let params = {
		sign,
		timestamp
	};
	return new WebSocket(config.websocket_host + url + '?' + qs.stringify(params));
}

